import { useState, useEffect, useRef } from "react";

import "./SectionedFeature.css";

function AnimatedText({ isActive, children }) {
    const [render, setRender] = useState(isActive);
    const [height, setHeight] = useState(0);
    const ref = useRef(null);

    useEffect(() => {
        if (isActive) {
            setRender(true);
        }
    }, [isActive]);

    useEffect(() => {
        if (render && ref.current) {
            requestAnimationFrame(() => {
                setHeight(ref.current.scrollHeight);
            });
        }
    }, [render, children]);

    const handleTransitionEnd = () => {
        if (!isActive) {
            setRender(false);
            setHeight(0);
        }
    };

    return (
        render && (
            <div
                ref={ref}
                className={"animation-text"}
                style={{
                    height: isActive ? height : 0,
                    opacity: isActive ? 1 : 0,
                }}
                onTransitionEnd={handleTransitionEnd}
            >
                {children}
            </div>
        )
    );
}

export default AnimatedText;
